import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { logoutUser } from '../../actions/userActions';

import Loader from '../General/Loader';

const Logout = props => {
  const { logoutUser, completeLogout } = props;
  useEffect(() => {
    logoutUser().then(() => completeLogout());
  }, [logoutUser]);
  return <Loader />;
};

Logout.propTypes = {
  logoutUser: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {};
};

export default connect(mapStateToProps, {
  logoutUser
})(Logout);
